document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header-drawer').forEach(function (drawer) {
    var mainDetails = drawer.querySelector('details');
    var mainSummary = mainDetails && mainDetails.querySelector('summary');
    if (!mainDetails || !mainSummary) return;

    function closeAllNested() {
      drawer.querySelectorAll('details').forEach(function (d) {
        if (d === mainDetails) return;
        d.removeAttribute('open');
        d.classList.remove('menu-opening');
      });
      drawer.querySelectorAll('.submenu-open').forEach(function (el) {
        el.classList.remove('submenu-open');
      });
    }

    function forceCloseMain() {
      mainDetails.removeAttribute('open');
      mainDetails.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden-tablet');
      mainSummary.setAttribute('aria-expanded', 'false');
      var header = document.querySelector('.section-header');
      if (header) header.classList.remove('menu-open');
      closeAllNested();
    }

    function forceOpenMain() {
      mainDetails.setAttribute('open', '');
      mainDetails.classList.add('menu-opening');
      document.body.classList.add('overflow-hidden-tablet');
      mainSummary.setAttribute('aria-expanded', 'true');
    }

    mainSummary.addEventListener('click', function () {
      setTimeout(function () {
        if (mainDetails.hasAttribute('open') && !mainDetails.classList.contains('menu-opening')) {
          forceOpenMain();
        }
      }, 60);
    });

    drawer.querySelectorAll('details').forEach(function (details) {
      if (details === mainDetails) return;
      var summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        var directSummary = event.target.closest('summary');
        if (directSummary !== summary) return;
        setTimeout(function () {
          var isOpen = details.hasAttribute('open');
          var parentMenu = details.closest('.has-submenu');
          if (isOpen) {
            details.classList.add('menu-opening');
            if (parentMenu) parentMenu.classList.add('submenu-open');
          } else {
            details.classList.remove('menu-opening');
            if (parentMenu) parentMenu.classList.remove('submenu-open');
          }
        }, 120);
      });
    });

    drawer.querySelectorAll('.menu-drawer__close-button').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var ownDetails = closeBtn.closest('details');
        if (!ownDetails) return;
        ownDetails.removeAttribute('open');
        ownDetails.classList.remove('menu-opening');
        var parentMenu = ownDetails.closest('.has-submenu');
        if (parentMenu) parentMenu.classList.remove('submenu-open');
        var ownSummary = ownDetails.querySelector('summary');
        if (ownSummary) ownSummary.setAttribute('aria-expanded', 'false');
      });
    });

    drawer.querySelectorAll('.closeMenu').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        forceCloseMain();
      });
    });

    document.querySelectorAll('.drawer-page-content, .overlay-click').forEach(function (el) {
      el.addEventListener('click', function () {
        if (document.body.classList.contains('overflow-hidden-tablet')) forceCloseMain();
      });
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && mainDetails.hasAttribute('open')) forceCloseMain();
    });
  });

  document.querySelectorAll('modal-opener').forEach(function (opener) {
    var button = opener.querySelector('button');
    var modalSelector = opener.getAttribute('data-modal');
    if (!button || !modalSelector) return;

    button.addEventListener('click', function () {
      var modal = document.querySelector(modalSelector);
      if (!modal) return;

      setTimeout(function () {
        if (!modal.hasAttribute('open')) {
          modal.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
          var dialog = modal.querySelector('[role="dialog"]');
          if (dialog) dialog.focus();
        }
      }, 60);
    });

    var closeBtn = document.querySelector(modalSelector + ' [id^="ModalClose-"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var modal = document.querySelector(modalSelector);
        if (!modal) return;
        modal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      });
    }
  });

  document.querySelectorAll('modal-dialog').forEach(function (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
    });
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('modal-dialog[open]').forEach(function (modal) {
      modal.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    });
  });

  document.querySelectorAll('details-modal').forEach(function (searchModal) {
    var details = searchModal.querySelector('details');
    var summary = searchModal.querySelector('summary');
    var closeBtn = searchModal.querySelector('button[type="button"]');
    if (!details || !summary) return;

    function focusInput() {
      var input = details.querySelector('input:not([type="hidden"])');
      if (input) {
        input.focus();
      }
    }

    function forceOpenSearch() {
      details.setAttribute('open', 'true');
      document.body.classList.add('overflow-hidden');
      summary.setAttribute('aria-expanded', 'true');
      setTimeout(focusInput, 80);
    }

    function forceCloseSearch() {
      details.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      summary.setAttribute('aria-expanded', 'false');
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (details.hasAttribute('open')) {
        forceCloseSearch();
      } else {
        forceOpenSearch();
      }
    }, true);

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        forceCloseSearch();
      });
    }

    document.addEventListener('click', function (event) {
      if (!details.hasAttribute('open')) return;
      if (searchModal.contains(event.target)) return;
      forceCloseSearch();
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && details.hasAttribute('open')) forceCloseSearch();
    });
  });
});
